import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ColoringImageService {

  constructor(private http: HttpClient) {}

  getAllColoringImage(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(
      `${environment.authUrl}/coloring-images`,
      {
        headers: { lang: langCode },
        params: { searchTerm }
      }
    );
  }

  createColoringImage(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/coloring-images`, data);
  }

  deleteColoringImage(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/coloring-images/${id}`
    );
  }
  deleteColoringImgTranslation(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/coloring-images/deleteTransalation/${id}`
    );
  }

  getColoringImgById(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/coloring-images/getOne/${id}`);
  }

  updateColoringImage(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.authUrl}/coloring-images/${id}`, data);
  }
}
